module.exports = __webpack_public_path__ + "static/media/rd-gcbanner.68a6a373.png";